import { render, staticRenderFns } from "./OpenLeadsByAccount.vue?vue&type=template&id=1503327d&"
import script from "./OpenLeadsByAccount.vue?vue&type=script&lang=js&"
export * from "./OpenLeadsByAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports